import React, { useState, useEffect } from "react";
import { Box, Grid } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { Section1 } from "./Sections/Section1";
import { Section2 } from "./Sections/Section2";
import OsterusLoader from "../../../../../../Loader";
import FilterDrawer from "../../../FilterDrawer";
import { EDUCATION_COMPARISON_INSIGHT } from "../../viewConstants";

const useStyles = makeStyles(() => ({
    loader: {
        position: "absolute",
        top: "50%",
        left: "47%",
        margin: "auto",
    },
    sectionContainer: {
        margin: "auto",
        padding: "0 16px",
        marginTop: -8,
        marginBottom: 8,
    },
    blur: {
        filter: "blur(4px)",
        WebkitFilter: "blur(4px)",
        pointerEvents: "none",
    },
}));

export function EducationView({ insightsData, stacks, isLoading, StackSelectComponent, HeaderComponent, headerProps }) {
    const classes = useStyles();
    const [filterDrawerOpen, setFilterDrawerOpen] = useState(false);
    const [canRenderCharts, setCanRenderCharts] = useState(false);

    useEffect(() => setTimeout(() => setCanRenderCharts(true), 1), []);

    return (
        <>
            {StackSelectComponent}
            <HeaderComponent
                viewType={EDUCATION_COMPARISON_INSIGHT}
                isSingle={false}
                selectedStacks={stacks}
                onFilterClicked={() => setFilterDrawerOpen(true)}
                isLoading={isLoading}
                {...headerProps}
            />
            <FilterDrawer
                anchorElementId="stack-select"
                open={filterDrawerOpen}
                onClose={() => setFilterDrawerOpen(false)}
            />
            <div className={`${classes.sectionContainer} ${isLoading ? classes.blur : ""}`} translate="no">
                {canRenderCharts && (
                    <Grid container>
                        <Grid xs={8}>
                            <Section1 stacks={stacks} data={insightsData.section1} />
                        </Grid>
                        <Grid xs={4}>
                            <Section2 stacks={stacks} data={insightsData.section2} />
                        </Grid>
                    </Grid>
                )}
            </div>
            {isLoading && (
                <Box className={classes.loader}>
                    <OsterusLoader />
                </Box>
            )}
        </>
    );
}
